/**
 * Created by eliranm on 05/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var template = require('content-templates/content-import/contentImportLayout.tmpl');
    var Config = require('content-config/contentImportConfig.json');
    var Button = require('ui/button/Button');

    var ContentImportLayout = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportLayout = Marionette.Layout.extend({
            template: template,
            className: 'content-import',
            regions: {
                instructionsRegion: '.instructions'
            },
            ui: {
                importButton: '.button-import',
                cancelButton: '.button-cancel'
            },
            uiComponents: {
                importButton: {
                    type: Button,
                    options: {
                        el: 'view.ui.importButton',
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        'click': '_triggerImport'
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: 'view.ui.cancelButton',
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        'click': '_triggerClosePage'
                    }
                }
            },


            // overridden

            initialize: function (options) {
                this.vent = options.vent;
            },

            onRender: function () {
                this._bindEvents();
                this.disableImport();
            },

            onClose: function () {
                this.uiComponents.importButton.close();
                this.uiComponents.cancelButton.close();
            },


            // public

            enableImport: function () {
                var importButton = this.uiComponents.importButton;
                importButton.setState(Button.STATES.ENABLED);
                importButton.setTooltip(null);
            },

            disableImport: function () {
                var importButton = this.uiComponents.importButton;
                importButton.setState(Button.STATES.DISABLED);
                importButton.setTooltip(this.model.getImportButtonDisabledTooltip());
            },


            // private

            _bindEvents: function () {
                this.listenTo(this, Config.events.closePage, this._triggerClosePage);
            },

            _triggerImport: function () {
                this.vent.trigger(Config.events.submitImport);
            },

            _triggerClosePage: function () {
                this.vent.trigger(Config.events.closePageDelegate);
            }

        });
    });

    return ContentImportLayout;
});
